<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row">
                    <h3 class="ml-2">Thông tin công việc</h3>
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">Chi nhánh</label>
                        <v-select class="" v-model="branchModel" :clearable="false" :options="branchOptions"
                                  data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'"
                                  name="branch">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                    <div class="vx-col lg:w-1/3 md:w-1/2 w-1/2 mt-2">
                        <label class="vs-input--label">Nhân viên</label>
                        <v-select :value="dailyWork.employeeString" :disabled="isUpdate" :clearable="false"
                                  :options="employeeOptions"
                                  @input="employee => updateEmployee(dailyWork, employee)" v-validate="'required'"/>
                    </div>
                </div>

                <div class="vx-row mt-3">
                    <div class="vx-col lg:w-2/4 md:w-1/2 w-1/2">
                        <vs-input :disabled="isUpdate" v-if="isUpdate" data-vv-validate-on="blur" name="dailyWorkName"
                                  class="w-full" v-validate="'required'" label="Tên công việc"
                                  v-model="dailyWork.name"/>
                        <span class="text-danger text-sm">{{ errors.first('dailyWorkName') }}</span>
                    </div>
                    <div v-if="isUpdate" class="vx-col md:w-1/6 sm:w-auto mr-4">
                        <label class="vs-input--label">Trạng thái</label>
                        <v-select class="" v-model="statusModel" :clearable="false" :options="statusOptions"/>
                    </div>
                    <div class="vx-col lg:w-1/3 md:w-1/2 w-1/2">
                        <vs-input v-if="isUpdate" :disabled="true" data-vv-validate-on="blur" class="w-full"
                                  label="Thời gian hoàn thành" v-model="dailyWork.displayUpdateStatusAt"/>
                    </div>
                </div>

                <div class="vx-row mt-3">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">Địa điểm</label>
                        <v-select :disabled="isUpdate" class="" v-model="placeModel" :clearable="false"
                                  :options="placeOptions"
                                  data-vv-validate-on="blur" v-validate="'required'" name="place"/>
                        <span class="text-danger text-sm">{{ errors.first('place') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">Khu vực</label>
                        <v-select :disabled="isUpdate" class="" v-model="areaModel" :clearable="false"
                                  :options="areaOptions"
                                  data-vv-validate-on="blur" v-validate="'required'" name="area"/>
                        <span class="text-danger text-sm">{{ errors.first('area') }}</span>
                    </div>
                </div>

                <div class="vx-row mt-3">
                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2">

                        <small class="date-label">Ngày bắt đầu</small>
                        <datepicker :format="'dd/MM/yyyy'" v-model="dailyWork.startDate"
                                    data-vv-validate-on="input" v-validate="'required'" name="startDate"></datepicker>
                        <span class="text-danger text-sm">{{ errors.first('startDate') }}</span>
                    </div>
                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2">
                        <small class="date-label">Thời gian bắt đầu</small>
                        <v-select :value="dailyWork.fromHourString" :clearable="false" :options="timeSpans"
                                  @input="fromHour => updateTimeSpan(dailyWork, fromHour, 'fromHour')"
                                  v-validate="'required'"/>
                    </div>
                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2">
                        <small class="date-label">Ngày kết thúc</small>
                        <datepicker :format="'dd/MM/yyyy'" v-model="dailyWork.endDate"
                                    data-vv-validate-on="input" v-validate="'required'" name="endDate"></datepicker>
                        <span class="text-danger text-sm">{{ errors.first('endDate') }}</span>
                    </div>
                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2">
                        <small class="date-label">Thời gian kết thúc</small>
                        <v-select :value="dailyWork.toHourString" :clearable="false" :options="timeSpans"
                                  @input="toHour => updateTimeSpan(dailyWork, toHour, 'toHour')"
                                  v-validate="'required'"/>
                    </div>
                </div>

                <div class="vx-row mt-3">
                    <div class="vx-col md:w-2/3 w-full mt-2">
                        <vs-textarea class="w-full" label="Thông tin bổ sung" v-model="dailyWork.description"
                                     name="metadata"/>
                        <span class="text-danger text-sm">{{ errors.first('metadata') }}</span>
                    </div>
                </div>
                <div v-if="isUpdate" class="vx-row mt-3">
                    Ảnh đính kèm
                    <div v-for="(item) in dailyWork.attachmentList" :key="item">
                        <img style="width: 300px; height: 400px; padding: 20px;" class="mt-6"
                             onerror="this.style.display = 'none'" :src="item">
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 mb-4 flex flex-wrap items-center justify-end">
                            <vs-button class="ml-auto mt-2" @click="saveChanges"
                                       :disabled="!validateForm || !employeeOptions.length">{{
                                    `${isUpdate ?
                                        'Cập nhật' : 'Giao việc'}`
                                }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">Quay lại
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";
import moment from "moment";

export default {
    components: {
        vSelect,
        Datepicker
    },
    data() {
        return {
            user_data: null,
            activeTab: 0,
            isUpdate: false,
            branchOptions: [],
            deviceOptions: [],
            deviceDatas: [],
            employeeOptions: [],
            employeeDatas: [],
            statusOptions: [
                {value: 0, label: 'Chờ'},
                {value: 1, label: 'Đang làm'},
                {value: 2, label: 'Hoàn thành'},
                {value: 3, label: 'Đã hủy'}
            ],
            dailyWork: {
                fromHourString: "00:00",
                toHourString: "00:00",
                employeeString: "",
                employeeId: null,
                buildingId: null,
                areaId: null,
                isCheckImg: null,
                isCheckStatus: null,
            },
            selectedOrganizationBranchValue: null,
            placeOptions: [],
            areaOptions: []
        }
    },
    created() {
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.selectedOrganizationBranchValue = this.$route.query.branch_id;
        let _this1 = this;
        this.loadPlace();
        this.loadEmployee().then(() => {
            this.updateEmployee(_this1.dailyWork, _this1.employeeOptions[0]);
            let id = this.$route.query.id;
            if (!id) return
            this.$crm.post("/daily-work/employee/find/" + id).then((response) => {
                let employee = this.employeeOptions.find(item => item.value == response.data.employeeId)
                this.updateEmployee(response.data, employee)
                let m = moment(response.data.workStartAt);
                response.data.startDate = m.unix() * 1000;
                this.updateTimeSpan(response.data, {
                    value: m.hour() * 60 + m.minute(),
                    label: utils.minuteToHour(m.hour() * 60 + m.minute())
                }, 'fromHour')
                m = moment(response.data.workEndAt);
                response.data.endDate = m.unix() * 1000;
                this.updateTimeSpan(response.data, {
                    value: m.hour() * 60 + m.minute(),
                    label: utils.minuteToHour(m.hour() * 60 + m.minute())
                }, 'toHour')
                this.dailyWork = response.data;
                this.dailyWork.displayUpdateStatusAt = response.data.updateStatusAt ? moment(response.data.updateStatusAt).format("DD/MM/YYYY HH:mm") : null;
                this.dailyWork.attachmentList = this.dailyWork.attachments.map(item => {
                    item = "https://api.intface.vn/crm/api/v1/daily-work/employee/image/" + this.dailyWork.id + "/" + item + "?access_token=" + localStorage.access_token;
                    return item;
                })
                this.loadAreaByPlace(this.dailyWork.buildingId);
                this.isUpdate = true
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        }).catch(function (err) {
            console.log(err);
        })
    },
    computed: {
        placeModel: {
            get() {
                return {
                    label: this.getLabelString(this.placeOptions.find(x => x.value == this.dailyWork.buildingId)),
                    value: this.dailyWork.buildingId
                }
            },
            set(obj) {
                this.dailyWork.buildingId = obj.value
                this.loadAreaByPlace(this.dailyWork.buildingId);
            }
        },
        areaModel: {
            get() {
                return {
                    label: this.getLabelString(this.areaOptions.find(x => x.value == this.dailyWork.areaId)),
                    value: this.dailyWork.areaId
                }
            },
            set(obj) {
                this.dailyWork.areaId = obj.value
            }
        },
        branchModel: {
            get() {
                return {
                    label: this.branchOptions.find(x => x.value == this.selectedOrganizationBranchValue).label,
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value;
                Promise.all([this.loadEmployee()]);
            }
        },
        statusModel: {
            get() {
                return {
                    label: this.getLabelString(this.statusOptions.find(x => x.value == this.dailyWork.status)),
                    value: this.dailyWork.status
                }
            },
            set(obj) {
                this.dailyWork.status = obj.value;
            }
        },
        validateForm() {
            return !this.errors.any()
        },
    },
    methods: {
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        updateTimeSpan(setting, hour, type) {
            setting[type] = hour.value;
            setting[`${type}String`] = hour.label;
        },
        loadPlace() {
            return new Promise((resolve) => {
                this.$crm.get('/building-type/find-all').then((place) => {
                    this.placeOptions = place.data.map(place => {
                        return {
                            label: place.name,
                            value: place.id
                        }
                    });
                    resolve();
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        loadAreaByPlace(id) {
            if (id) {
                return new Promise((resolve) => {
                    this.$crm.get('/area/find-by-place_id/' + id).then((response) => {
                        this.areaOptions = response.data.map(area => {
                            return {
                                label: area.name,
                                value: area.id
                            }
                        });
                        resolve();
                    })
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            }
        },
        loadEmployee() {
            return new Promise((resolve, reject) => {
                if (!this.selectedOrganizationBranchValue) return reject();
                this.$vs.loading();
                this.$crm.post('/employee/find-by-organization-branch/' + this.selectedOrganizationBranchValue).then((response) => {
                    this.employeeData = response.data;
                    this.$vs.loading.close();
                    if (response.data.length == 0) {
                        reject()
                        this.employeeOptions = []
                        return this.$vs.notify({
                            title: 'Có lỗi sảy ra!',
                            text: 'Không tồn tại nhân viên nào',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                    }
                    this.employeeOptions = response.data.map(item => {
                        return {
                            value: item.employeeId,
                            label: item.employeeCode + " " + item.fullName
                        }
                    });
                    resolve()
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        updateEmployee(setting, employee) {
            setting.employeeString = employee.label;
            setting.employeeId = employee.value;
        },
        updateDevice(setting, device) {
            setting.deviceString = device.label;
            setting.deviceId = device.value;
        },
        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;

                const result = await this.$validator.validateAll();
                if (!result) {
                    return;
                }
                if (!this.dailyWork.buildingId) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Địa điểm làm việc chưa được chọn",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                if (!this.dailyWork.areaId) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Khu vực làm việc chưa được chọn",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                if (new Date(this.dailyWork.startDate).getTime() > new Date(this.dailyWork.endDate).getTime()) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Ngày kết thúc phải lơn hơn bắt đầu.",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                if (!this.dailyWork.fromHour) this.dailyWork.fromHour = 0;
                if (!this.dailyWork.toHour) this.dailyWork.toHour = 0;
                if (new Date(this.dailyWork.startDate).getTime() == new Date(this.dailyWork.endDate).getTime() && this.dailyWork.fromHour >= this.dailyWork.toHour) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Thời gian kết thúc phải lớn hơn bắt đầu.",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                let _this2 = this;
                let _moment = moment;
                this.dailyWork.workStartAt = _moment(_this2.dailyWork.startDate).set({
                    hour: 0,
                    minute: 0,
                    secomd: 0
                }).add(_this2.dailyWork.fromHour, "m")
                this.dailyWork.workEndAt = _moment(_this2.dailyWork.endDate).set({
                    hour: 0,
                    minute: 0,
                    secomd: 0
                }).add(_this2.dailyWork.toHour, "m")
                let url = `/daily-work/employee/assign/${this.$route.query.branch_id}`, data = [this.dailyWork];
                if (this.isUpdate) {
                    url = '/daily-work/employee/admin-update/' + this.$route.query.id;
                    data = this.dailyWork
                }
                this.$vs.loading();
                this.$crm.post(url, data).then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: this.isUpdate ? 'Cập nhật thành công' : 'Thêm mới thành công',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    this.$router.push(`/user/daily-work-result${this.selectedOrganizationBranchValue ? `?branch_id=${this.selectedOrganizationBranchValue}` : ''}`).catch(() => {
                    })
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (e) {
                console.log(e);
            }
        },
        addNewRecord() {
            let id = this.$route.query.id;
            if (id) {
                this.$crm.post('/device/find-assigned-device-by-id/' + id).then((response) => {
                    if (response.data && response.data.length) {
                        this.isUpdate = true;
                        this.dailyWork = response.data[0]
                    }
                    let employee = this.employeeOptions.find(item => item.value == this.dailyWork.employeeId);
                    this.updateEmployee(this.dailyWork, employee || this.employeeOptions[0]);
                    let device;
                    if (this.$route.query.device_id) {
                        device = this.deviceOptions.find(item => item.value == this.$route.query.device_id);
                    }
                    this.updateDevice(this.dailyWork, device || this.deviceOptions[0])
                    this.$vs.loading.close();

                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } else {
                this.dailyWork = {
                    quantity: 1,
                }
                this.updateEmployee(this.dailyWork, this.employeeOptions[0]);
                let device;
                if (this.$route.query.device_id) {
                    device = this.deviceOptions.find(item => item.value == this.$route.query.device_id);
                }
                this.updateDevice(this.dailyWork, device || this.deviceOptions[0])
            }
        },
        deleteRecord(index) {
            this.dailyWork.splice(index, 1)
        }
    },
}
</script>

<style scoped>

</style>
